/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';
import { connect } from 'react-redux';
import { setLang } from './redux/actions';

import { I18n } from '@aws-amplify/core';
import { translations } from "@aws-amplify/ui-react";

/*
 * Load SignInContainer for SingIn/SingUp
 */
import SignInContainer from './components/LandingPage/signInContainer';

/*
 * Load i18n Localization
 */
const lang = navigator.languages[0];
try {
	const configTranslations = {};

	const sanitizedLang = lang.split("-")[0];
	console.debug(sanitizedLang)
	const translationModule = await import(
		`./translations/${sanitizedLang}.json`
	);
	configTranslations[sanitizedLang] = translationModule.default.widget;
	I18n.putVocabularies(configTranslations);
} catch (error) {
	console.warn(`No translation file for ${lang}`);
}

/*
 *  Load Default Language
 * Check Browser Language: If it exists in i18n then use the Browser Language, else use default "en"
 */
const loadDefaultLanguage = () => {
	const navLang = navigator.language.substr(0, 2);

	if (translations.hasOwnProperty(navLang)) {
		I18n.setLanguage(navLang);
		return navLang;
	}
	else {
		I18n.setLanguage("en");
		return "en";
	}
}

/*
 * Map lang state to p
 */
const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
	}
}

class App extends React.Component {
	constructor(props) {
		super(props);

		this.props.setLang(loadDefaultLanguage());

		this.state = {};
	}

	render() {
		return (
			<div>
				<SignInContainer />
			</div>
		);
	}
}

export default connect(mapStateToProps, { setLang })(App);
